export const siteInfo = {
  name: "咖位观察局",
  shortName: "咖位局",
  tagline: "看懂同框里的门道",
  slogan: "网红明星跨界对比 · 理性吃瓜看门道",
  description:
    "咖位观察局聚焦网红与明星的跨界对比，深挖同框名场面、咖位差距与热度走势，用维度化的方式拆解流量与地位的变迁。",
  email: "hello@kawei-observer.cn",
  mediaEmail: "media@kawei-observer.cn",
  founded: "2021",
  updateFrequency: "每周更新 3 篇深度解读",
};

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "对比榜单", path: "/compare" },
  { label: "深度解读", path: "/articles" },
  { label: "关于我们", path: "/about" },
  { label: "常见问题", path: "/faq" },
];

export const footerGroups = [
  {
    title: "内容栏目",
    links: [
      { label: "对比榜单", path: "/compare" },
      { label: "深度解读", path: "/articles" },
      { label: "同框名场面", path: "/compare" },
      { label: "热度走势", path: "/articles" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", path: "/about" },
      { label: "常见问题", path: "/faq" },
      { label: "订阅与反馈", path: "/#subscribe" },
    ],
  },
];

export const hotKeywords = [
  "网红明星",
  "跨界对比",
  "咖位对比",
  "谁更火",
  "同框名场面",
  "热度走势",
  "流量变迁",
];

export const categoryFilters = [
  { key: "all", label: "全部" },
  { key: "直播同框", label: "直播同框" },
  { key: "品牌代言", label: "品牌代言" },
  { key: "综艺同台", label: "综艺同台" },
  { key: "时尚红毯", label: "时尚红毯" },
  { key: "影视选角", label: "影视选角" },
];

export const articleCategories = [
  { key: "all", label: "全部专题" },
  { key: "咖位方法论", label: "咖位方法论" },
  { key: "同框解析", label: "同框解析" },
  { key: "流量观察", label: "流量观察" },
  { key: "商业价值", label: "商业价值" },
];

export const principles = [
  {
    title: "维度先于结论",
    desc: "任何一次对比都先列出可量化的维度，再给判断，避免用一句「谁更红」草草收场。",
  },
  {
    title: "数据可追溯",
    desc: "热度、话题量、代言层级等指标均标注来源区间与统计口径，方便你自己复核。",
  },
  {
    title: "拒绝拉踩情绪",
    desc: "我们讨论的是行业现象与位置关系，不针对个人进行人身评价与恶意贬损。",
  },
  {
    title: "承认不确定性",
    desc: "流量是流动的，今天的排位不代表明天，我们会在文中明确标注时效。",
  },
];

export const testimonials = [
  {
    name: "林小满",
    role: "品牌市场策划",
    content:
      "选代言人前我习惯先来翻翻这里的对比维度，把「热度」和「形象契合度」拆开看，提案时说服力强了不少。",
  },
  {
    name: "周屿",
    role: "内容创作者",
    content:
      "很少有账号愿意把「咖位」这种玄学讲成可量化的东西，这里的同框解析看得很过瘾，逻辑清楚。",
  },
  {
    name: "陈默",
    role: "影视行业从业者",
    content:
      "热度涨跌我平时也能感觉到，但很少有人系统梳理成趋势线。这里的月度走势图我几乎每期都看。",
  },
];

export const milestones = [
  { year: "2021", event: "以「同框解析」专栏起步，从综艺同台镜头分配切入对比话题。" },
  { year: "2022", event: "上线咖位维度打分体系，把热度、话题、商业、专业四项拆开评估。" },
  { year: "2023", event: "推出月度热度走势板块，开始用趋势线记录流量变迁。" },
  { year: "2025", event: "覆盖直播、代言、红毯、选角四大赛场，形成稳定的对比内容矩阵。" },
];